import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import LoaderComponent from '@components/LoaderComponent';
import { toastError } from '@components/Toast';

import AddMember from '@features/order/components/AddMember';
import CommercialInvoice from '@features/order/components/commercial-invoice/CommercialInvoice';
import MaterialListTab from '@features/order/components/MaterialListTab';
import TeamTab from '@features/order/components/OrderDetailsTeamTab';
import Payment from '@features/order/components/payment/Payment';
import ProformaInvoice from '@features/order/components/ProformaInvoice';
import SalesContract from '@features/order/components/SalesContract';
import Supplier from '@features/order/components/Supplier';
import OrderInfoDetails from '@features/order/components/orderInfo/OrderInfoDetails';
import FactoryPO from '@features/order/components/factory-po/FactoryPO';

import { fetchOrderPlaceWorkflow } from '@store/orders/actions';

import ApiClient from '@lib/apiClient';

import { generateRandomString } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

const OrderDetails = ({
	orderId,
	currentStep,
	type,
	isDrafted,
	poItemIdentifier,
	productRefNumber,
	orderCancelInfo,
	getOrderCancelInfo,
	setOpenOrderDesignModal
}) => {
	const [currentDetails, setCurrentDetails] = useState([]);
	const [loading] = useState(false);
	const dispatch = useDispatch();
	const [stylesCount, setStylesCount] = useState(0);

	useEffect(() => {
		fetchOrderDesign();
	}, [orderId]);

	const fetchOrderDesign = async () => {
		try {
			const data = await ApiClient.GET(`${BASE_URL}/order/${orderId}/products-with-status`, '', true);
			setStylesCount(data?.data?.length);
		} catch (err) {
			toastError(err.response.data.message);
		}
	};

	useEffect(() => {
		dispatch(fetchOrderPlaceWorkflow(orderId)).then((response) => {
			setCurrentDetails(response);
		});
	}, [currentStep]);

	let details = currentDetails?.filter((item) => item?.stepName === currentStep);

	const renderCurrentStage = (currentStep) => {
		switch (currentStep) {
			case 'Order info':
				return (
					<OrderInfoDetails
						orderId={orderId}
						orderCancelInfo={orderCancelInfo}
						getOrderCancelInfo={getOrderCancelInfo}
						isDrafted={isDrafted}
						stylesCount={stylesCount}
						poItemIdentifier={poItemIdentifier}
						productRefNumber={productRefNumber}
						setOpenOrderDesignModal={setOpenOrderDesignModal}
					/>
				);
			case 'PI':
				return <ProformaInvoice orderId={orderId} orderStage={type} stylesCount={stylesCount} />;
			case 'Supplier':
				return <Supplier orderId={orderId} />;
			case 'Sales contract':
				return <SalesContract orderId={orderId} />;
			case 'Factory PO':
				return <FactoryPO orderId={orderId} />;
			case 'Materials':
				return <MaterialListTab id={orderId} />;
			case 'Team':
				return <TeamTab id={orderId} />;
			case 'Commercial':
				return <CommercialInvoice orderId={orderId} poItemIdentifier={poItemIdentifier} />;
			case 'Payment':
				return <Payment orderId={orderId} />;
			default:
				break;
		}
	};

	const showAddMember = ['Commercial', 'Payment'];

	return (
		<LoaderComponent loading={loading}>
			{type === 'PENDING' && (
				<div className={`order-container-with-sidebar ${!isDrafted ? 'd-flex' : ''}`}>
					<div className="create-container-with-add-people w-100">
						{renderCurrentStage(currentStep)}
					</div>
				</div>
			)}

			{type !== 'PENDING' && (
				<div className={`order-container-with-sidebar d-flex`}>
					<div className="create-container-with-add-people">
						{showAddMember.includes(currentStep) && (
							<div key={generateRandomString()}>
								<AddMember currentStepDetails={details[0]} orderId={orderId} />
							</div>
						)}
						{renderCurrentStage(currentStep)}
					</div>
				</div>
			)}
		</LoaderComponent>
	);
};

export default OrderDetails;
